<template>
  <div id="AttendanceManagement_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            差勤管理
          </div>
        </div>
      </div>
      <div class="cotent">
        <div
          class="thumbnail"
          @click="$router.push({name: 'AttendanceManagement_Clock'})"
        >
          <i
            class="icon-punch"
            aria-hidden="true"
          />
          <div class="caption">
            打卡
          </div>
          <div class="tip">
            上班／下班 線上打卡
          </div>
        </div>
        <div
          class="thumbnail"
          @click="$router.push({name: 'AttendanceRecord'})"
        >
          <i
            class="icon-record"
            aria-hidden="true"
          />
          <div class="caption">
            紀錄
          </div>
          <div class="tip">
            檢視上班／下班差勤紀錄
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  beforeRouteEnter (to, from, next) {
    console.log(to)
    next(vm => {
      axios(`${process.env.VUE_APP_CORE_URL}/api/Auth/UserInfo`, {
        method: 'GET',
        headers: {
          kingnetauth: `Cookies ${vm.$getCookie('comLoginToken').replace('token=', '')}`
        }
      }).then((res) => {
        console.log(res.data.Data)
        if (res.data.Data.IsAuthorizationAccount === false) {
          vm.$alert('您無權限操作此功能，請使用手機帳號重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            vm.$toMainPage()
            return false
          })
        } else {
          next()
        }
      }).catch(() => {})
    })
  },
  data () {
    return {

    }
  },
  mounted () {
    if (this.$isServiceEnabled(4)) { // 有開啟打卡功能
      apiAttendanceManagement.GetCommunityClockAuth().then(res => {
        if (res.status === 200) {
          if (res.data.Data.IsOpenCrossCommunityClock) { // 有開啟跨案場打卡
            localStorage.setItem('CrossCommunityClock', JSON.stringify(res.data.Data))
          } else {
            this.$toPage('serviceManager')
          }
        }
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
      })
    } else {
      this.$alert('貴社區未啟用此功能', '錯誤', {
        confirmButtonText: '確定',
        type: 'error',
        callback: action => {
          this.$toMainPage()
        }
      })
    }
  }
}
</script>
<style lang="sass" scoped>
#AttendanceManagement_main
  +mainLayer
  .cotent
    padding: 50px 0
    width: 490px
    margin: 0 auto
    display: flex
  .thumbnail
    padding-top: 45px
    padding-bottom: 20px
    width: 215px
    flex: 0 0 215px
    background-color: $white
    margin: 15px
    text-align: center
    align-items: center
    justify-content: center
    cursor: pointer
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3)
    border-radius: $pageBorderRadius
    &:hover
      background-color: $whiteHover
    i
      width: 100%
      height: 30%
      color: $mainColor
      font-size: 60px
    .caption
      display: block
      font-size: 30px
      color: #4B4B4B
      margin-top: 25px
    .tip
      display: block
      margin-top: 10px
      margin-bottom: 10px
</style>
